export const ACTIVE_OFFER_STATES: OfferStatus[] = ['ACTIVE', 'EXTENDED'];
export const AUCTION_TYPES: OfferType[] = ['AUCTION', 'ENFORCED_AUCTION'];